import { Circle, Group, Text } from 'react-konva';
import { calcInputPos, width } from './WorkflowItem';

function InputPin(props) {
	const { index, name, onInputClick, onInputDblClick, onInputCircleDblClick, enabled, minified } = props;
	const pos = calcInputPos(index);

	return (
		<Group>

			<Text text={name} fontSize={9} fill='black' opacity={enabled ? 1 : 0.3} width={width} x={5} y={pos.y - 4} hitStrokeWidth={5} onDblClick={() => { onInputDblClick(name, pos); }} />

			{enabled && <Circle x={pos.x} y={pos.y} fill={minified ? '#cccccc' : '#1b2330'} radius={5} hitStrokeWidth={5} onPointerClick={() => onInputClick(name, pos)} onDblClick={(evt) => { evt.cancelBubble = true; onInputCircleDblClick(name, pos); }} />}

		</Group>
	);
}

export default InputPin;
